export default "__VITE_ASSET__iGtkKnvh__"